import { connect } from 'react-redux';
import { IApplicationState } from '../../types/redux';
import { changeTabs } from '../../actions/location';
import { WhatIsHome } from '../../components/WhatIsHome';

const mapStateToProps = (state: IApplicationState) => ({ tabs: state.tabs });
const mapDispatchToProps = { changeTabs };

export const WhatIsHomeContainer = connect(mapStateToProps, mapDispatchToProps)(WhatIsHome);
